var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleClickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22482_6344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5372 13.2768L7.97472 7.55812C7.71859 7.46475 7.43022 7.52789 7.23728 7.72153C7.04434 7.91446 6.98045 8.20218 7.07387 8.45896L12.7926 24.0214C12.8922 24.2954 13.1504 24.4794 13.4421 24.4842C13.7303 24.4889 13.9967 24.3149 14.1061 24.042L16.8067 17.2909L23.5577 14.5904C23.8289 14.4819 24.0047 14.2175 23.9999 13.9264C23.9951 13.6346 23.8111 13.3764 23.5372 13.2768Z",
    fill: "url(#paint0_linear_22482_6344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8468 8.22697C16.4911 3.88533 12.7977 0.484375 8.43747 0.484375C3.78477 0.484375 0 4.26914 0 8.92184C0 13.282 3.40096 16.9755 7.74259 17.3311C8.24116 17.3655 8.47937 16.955 8.50136 16.6877C8.53295 16.3005 8.24453 15.9613 7.85795 15.929C4.24001 15.6331 1.40624 12.5549 1.40624 8.92184C1.40624 5.04506 4.56069 1.89062 8.43747 1.89062C12.0705 1.89062 15.1487 4.72439 15.4446 8.34233C15.4769 8.7289 15.8127 9.01662 16.2034 8.98573C16.59 8.95344 16.8784 8.6142 16.8468 8.22697ZM8.43747 3.29686C5.3359 3.29686 2.81249 5.82028 2.81249 8.92184C2.81249 11.2276 4.25994 13.3369 6.41322 14.1706C6.77557 14.3101 7.183 14.131 7.32302 13.7689C7.46308 13.4064 7.28317 12.9992 6.92135 12.8591C5.30501 12.2335 4.21873 10.6515 4.21873 8.92184C4.21873 6.59549 6.11112 4.70311 8.43747 4.70311C10.1671 4.70311 11.7491 5.78939 12.3747 7.40572C12.5141 7.76825 12.9206 7.9475 13.2845 7.80739C13.6463 7.66733 13.8262 7.26013 13.6861 6.8976C12.8526 4.74431 10.7432 3.29686 8.43747 3.29686Z",
    fill: "url(#paint1_linear_22482_6344)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22482_6344",
    x1: 7.03149,
    y1: 16,
    x2: 24,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22482_6344",
    x1: 0,
    y1: 8.90877,
    x2: 16.8491,
    y2: 8.90877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1CBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBE2FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22482_6344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.484375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleClickIcon);
export default __webpack_public_path__ + "static/media/double-click-icon.0a094a909b876f73d2e2ed7f25b46b4f.svg";
export { ForwardRef as ReactComponent };